import _ from 'lodash';
import snakeCaseKeys from 'snakecase-keys';
import {app} from '@/lib/app';
import {utils} from '@/lib/utils';
import {INewsSortState, INews} from '@/@types/models/news';

const {axios} = app;
const env = app.env.get();
const resources = '/news';
const limit = 10;

export const getPagination = async (
  current: number,
  searchWords: string[],
  sortState: INewsSortState
): Promise<any> => {
  try {
    let url;

    // TODO: utils関数化する (makeHitColumnsQuery('name', 'price', 'prefectures'))
    // クエリパラメータのソートを判定
    const sort =
      sortState.order === 'desc'
        ? `%2b${_.snakeCase(sortState.key)}`
        : `%2d${_.snakeCase(sortState.key)}`;

    // クエリパラメータの検索ワードを判定
    if (searchWords.length !== 0) {
      const search = searchWords.join('%20');

      url = `${resources}_paging?page=${current}&limit=${limit}&sort=${sort}&keyword=${search}`;
    } else {
      url = `${resources}_paging?page=${current}&limit=${limit}&sort=${sort}`;
    }

    const res = await axios.base.get(url);

    const result = {
      pages: res.data.pages,
      totalCount: Number(res.headers['x-total-count']),
      totalPages: Number(res.headers['x-total-pages']),
      current,
    };

    return result;
  } catch (err) {
    throw new Error(err as any);
  }
};

export const getOne = async (id: number) => {
  try {
    const {data} = await axios.base.get(`${resources}/${id}`);
    return data;
  } catch (err) {
    throw new Error(err as any);
  }
};

export const update = async (news: any) => {
  const reqbody = {
    ...news,
    end_disclose: news.endDisclose + ' 23:59:59',
  };

  try {
    const {data} = await axios.auth.put(
      `${resources}/${news.id}`,
      snakeCaseKeys(reqbody)
    );
    return data;
  } catch (err) {
    throw new Error(err as any);
  }
};

export const destroy = async (news: INews) => {
  try {
    const {data} = await axios.auth.delete(`${resources}/${news.id}`);
    return data;
  } catch (err) {
    throw new Error(err as any);
  }
};

export const create = async (news: any) => {
  try {
    const reqbody = {
      ...news,
      end_disclose: news.endDisclose + ' 23:59:59',
    };

    const {data} = await axios.auth.post(
      `${resources}`,
      snakeCaseKeys(reqbody)
    );
    return data;
  } catch (err) {
    throw new Error(err as any);
  }
};
